import isNil from 'lodash/isNil';



const getTestPushNotificationData = (values) => {
  const formData = new FormData();
  const fileProp = 'originFileObj';

  formData.append('template_id', values.template_id);
  formData.append('user_token', values.user_token);
  const data = values.data || {};

  Object.entries(data).forEach(([ fieldName, field ]) => {
    const templateFieldId = field.template_field_id ?? 'null';
    const { value } = field;

    formData.append(`data[${fieldName}][template_field_id]`, templateFieldId);

    if (Array.isArray(field.value) && field.value[0]?.hasOwnProperty(fileProp)) {
      formData.append(`data[${fieldName}][value]`, field.value[0][fileProp]);
    } else if (isNil(value) || (Array.isArray(value) && value.length === 0)) {
      formData.append(`data[${fieldName}][value]`, 'null');
    } else if (Array.isArray(value)) {
      value.forEach((item) => {
        formData.append(`data[${fieldName}][value]`, item);
      });
    } else {
      formData.append(`data[${fieldName}][value]`, value);
    }
  });

  return formData;
};

export default getTestPushNotificationData;
